import { render, staticRenderFns } from "./NormalDisplay.vue?vue&type=template&id=45abfb1e&"
import script from "./NormalDisplay.vue?vue&type=script&lang=js&"
export * from "./NormalDisplay.vue?vue&type=script&lang=js&"
import style0 from "./NormalDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports